import { Pipe, PipeTransform } from '@angular/core';

import { t } from '../helpers/translation.helper';
import { TranslationParams } from '../services/translation.service';
import { TranslationKey } from '../types/translation-keys.type';

@Pipe({
  name: 't',
  pure: false,
})
export class TranslationPipe implements PipeTransform {

  constructor() {}
  
  transform(key: TranslationKey | null | undefined, params?: TranslationParams): string {
    if (!key) {
      return '';
    }
    try {
      return t(key, params);
    } catch (error) {
      console.error(`Translation failed for key "${key}":`, error);
      return key;
    }
  }
}
